import { takeEvery, put, call } from "redux-saga/effects";

import {
  getCityAPI,
  addCityAPI,
  getCitiesAPI,
  updateCityAPI,
  deleteCityAPI,
} from "../../../helpers/backend.helper";
import {
  GET_CITIES,
  ADD_CITY,
  GET_CITY,
  UPDATE_CITY,
  DELETE_CITY,
} from "./actionTypes";
import {
  addCityError,
  addCitySuccess,
  deleteCityError,
  deleteCitySuccess,
  getCityError,
  getCitiesError,
  getCitiesSuccess,
  getCitySuccess,
  updateCityError,
  updateCitySuccess,
} from "./actions";

function* getCities({ payload: { request } }) {
  try {
    const response = yield call(getCitiesAPI, request);
    if (response) {
      yield put(getCitiesSuccess(response?.data));
    }
  } catch (error) {
    yield put(getCitiesError(error));
  }
}

function* addCity({ payload: { request } }) {
  try {
    const response = yield call(addCityAPI, request);
    if (response) {
      yield put(addCitySuccess());
    }
  } catch (error) {
    yield put(addCityError(error));
  }
}

function* getCity({ payload: { id } }) {
  try {
    const response = yield call(getCityAPI, id);
    if (response) {
      yield put(getCitySuccess(response?.data));
    }
  } catch (error) {
    yield put(getCityError(error));
  }
}

function* updateCity({ payload: { request } }) {
  try {
    const response = yield call(updateCityAPI, request);
    if (response) {
      yield put(updateCitySuccess());
    }
  } catch (error) {
    yield put(updateCityError(error));
  }
}

function* deleteCity({ payload: { id } }) {
  try {
    const response = yield call(deleteCityAPI, id);
    if (response) {
      yield put(deleteCitySuccess());
    }
  } catch (error) {
    yield put(deleteCityError(error));
  }
}

function* citiesSaga() {
  yield takeEvery(GET_CITIES, getCities);
  yield takeEvery(ADD_CITY, addCity);
  yield takeEvery(GET_CITY, getCity);
  yield takeEvery(UPDATE_CITY, updateCity);
  yield takeEvery(DELETE_CITY, deleteCity);
}

export default citiesSaga;
